import PurchaseOrdersList from "@/components/inventory/purchase-orders/PurchaseOrdersList";
import { useAppSelector } from "@/redux/features/hooks";

const PurchaseOrdersPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);
  if (!restaurant) return null;
  return <PurchaseOrdersList restaurantId={restaurant.id} />;
};

export default PurchaseOrdersPage;
